import React from 'react'
import { connect } from 'react-redux'
import Popup from 'reactjs-popup'
import * as actions from '../redux/actions'
import { MdClose } from 'react-icons/md'
import sendMessageWPP from './sendMessageWPP'
import { supportPhone } from './defaultProps'
import { centsToText } from './MoneyHelper'
import moment from 'moment'

const styles = {
  popupContentContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '8px',
    paddingLeft: '16px',
    paddingRight: '16px',
    position: 'relative'
  },
  popupHeader: {
    margin: '0',
    textAlign: 'center',
    color: '#6c367a'
  },
  popupParagraph: {
    textAlign: 'center'
  },
  popupDivisor: {
    width: '100%',
    margin: '8px',
    backgroundColor: '#a2a2a2',
    height: '1px'
  },
  popupLink: {
    textDecoration: 'underline'
  },
  popupButtonsSection: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  },
  popupAcceptButton: {
    backgroundColor: '#1f8408',
    color: '#ffffff',
    cursor: 'pointer',
    width: '50%',
    textAlign: 'center',
    borderRadius: '16px',
    margin: '8px',
    boxShadow: 'rgba(32, 3, 61, 0.55) 0px 4px 4px',
    padding: '8px',
    fontWeight: 'bold'
  },
  popupRejectButton: {
    backgroundColor: '#d02020',
    color: '#ffffff',
    cursor: 'pointer',
    width: '50%',
    textAlign: 'center',
    borderRadius: '16px',
    margin: '8px',
    boxShadow: 'rgba(32, 3, 61, 0.55) 0px 4px 4px',
    padding: '8px',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  popupContentStyle: {
    maxWidth: '768px',
    width: '100%',
    borderRadius: '16px',
    margin: 'auto'
  },
  popupOverlayStyle: {
    padding: '16px'
  },
  closePopup: {
    backgroundColor: 'white',
    boxShadow: 'rgba(32, 3, 61, 0.55) 0px 4px 4px',
    width: '40px',
    height: '40px',
    borderRadius: 150,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: '-15px',
    top: '-15px'
  },
  pendingBillingCard: {
    boxShadow: '3px 4px 14px -3px #000000',
    width: '100%',
    border: '1px solid #6c367a',
    borderRadius: '8px',
    padding: '8px',
    boxSizing: 'border-box',
    marginBottom: '8px'
  },
  billingCardText: {
    color: '#6c367a'
  },
  pendingBillings: {
    width: '100%',
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  ellipsis: {
    color: '#6c367a',
    marginBottom: '8px',
    fontSize: '20px'
  }
}

class NotificationPopup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showPopup: false,
      type: 'blockedApp', // can be: pendingBilling | blockedApp
      wasClosed: false
    }
  }

  componentDidMount = () => {
    this.verifyPopupStatus()
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.props.isAppBlocked !== prevProps.isAppBlocked ||
      this.props.pendingBillings.length !== prevProps.pendingBillings.length ||
      this.props.currentRoute !== prevProps.currentRoute
    ) {
      this.verifyPopupStatus()
    }
  }

  verifyPopupStatus = () => {
    let popupType

    if (this.props.pendingBillings.length !== 0) { popupType = 'pendingBilling' }

    if (this.props.isAppBlocked) { popupType = 'blockedApp' }

    if (!popupType) return

    this.setState({
      type: popupType
    })

    if (popupType === 'pendingBilling') {
      if (!this.state.wasClosed) {
        this.setState({ showPopup: true })
      }
    } else {
      if (
        this.props.currentRoute.includes('/minhas-compras')
      ) {
        if (this.state.wasClosed) {
          this.setState({ showPopup: false })
        } else {
          this.setState({ showPopup: true })
        }
      } else {
        this.setState({ showPopup: true })
      }
    }
  }

  renderPendingBillings = () => {
    const firstTwoPendingBillings = this.props.pendingBillings.slice(0, 2)

    return firstTwoPendingBillings.map(billing => (
      <div style={styles.pendingBillingCard} key={billing.id}>
        <div style={styles.billingCardText}>Serviço: {billing.clientService.consultantService.name}</div>
        <div style={styles.billingCardText}>Preço: {centsToText(billing.price)}</div>
        <div style={styles.billingCardText}>Vencimento: {moment(billing.dueDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</div>
      </div>
    ))
  }

  navigateToBillingScreen = () => {
    this.props.historyPush('/cobrancas')
    this.closePopup()
  }

  closePopup = () => {
    this.setState({
      showPopup: false,
      wasClosed: true
    })
  }

  renderClosePopupButton = () => {
    if (this.state.type === 'blockedApp') {
      if (this.props.currentRoute.includes('/minhas-compras')) {
        return (
          <div style={styles.closePopup} onClick={this.closePopup}>
            <MdClose color='#6c367a' size={20} />
          </div>
        )
      } else {
        return null
      }
    } else {
      return (
        <div style={styles.closePopup} onClick={this.closePopup}>
          <MdClose color='#6c367a' size={20} />
        </div>
      )
    }
  }

  renderBlockedAppPopupContent = () => {
    return (
      <div style={styles.popupContentContainer}>
        {this.renderClosePopupButton()}
        <h2 style={styles.popupHeader}>
          Acesso ao aplicativo restrito
        </h2>
        <div style={styles.popupDivisor} />
        <p style={styles.popupParagraph}>
          Devido ao vencimento de uma ou mais cobranças, seu acesso ao aplicativo foi restrito.
        </p>
        <p style={styles.popupParagraph}>
          Para voltar a ter o acesso completo, realize o pagamento da cobrança.
        </p>
        <p style={styles.popupParagraph}>
          Se acha que isso pode ser um erro ou tem alguma dúvida, entre em contato com nosso suporte!
        </p>
        <div style={styles.popupButtonsSection}>
          <div style={styles.popupAcceptButton}
            onClick={this.navigateToBillingScreen}
          >
            Realizar o pagamento da cobrança
          </div>
          <div style={styles.popupRejectButton}
            onClick={() => sendMessageWPP(supportPhone, `Olá, sou cliente Mosty. Me chamo ${this.props.user.name} e desejo falar com o Suporte, pois o acesso à minha conta foi restrito.`)}
          >
            Contatar o suporte
          </div>
        </div>
      </div>
    )
  }

  renderEllipsis = () => {
    if (this.props.pendingBillings.length > 2) { return <div>...</div> } else { return null }
  }

  renderPendingBillingsPopupContent = () => {
    return (
      <div style={styles.popupContentContainer}>
        {this.renderClosePopupButton()}
        <h2 style={styles.popupHeader}>
          Há cobranças não pagas
        </h2>
        <div style={styles.popupDivisor} />
        <div style={styles.popupParagraph}>
        Sua consultora adicionou algumas cobranças de serviços recentes. Realize o pagamento até o dia do vencimento!
        </div>
        <div style={styles.pendingBillings}>
          {this.renderPendingBillings()}
          {this.renderEllipsis()}
        </div>
        <div style={styles.popupButtonsSection}>
          <div style={styles.popupAcceptButton}
            onClick={this.navigateToBillingScreen}
          >
            Pagar cobranças
          </div>
        </div>
      </div>
    )
  }

  renderPopup = () => {
    return (
      <Popup
        open={this.state.showPopup}
        position='right center'
        contentStyle={styles.popupContentStyle}
        overlayStyle={styles.popupOverlayStyle}
        closeOnDocumentClick={false}
      >
        <div className='modal'
        >
          {this.state.type === 'blockedApp'
            ? this.renderBlockedAppPopupContent()
            : this.renderPendingBillingsPopupContent()}
        </div>
      </Popup>
    )
  }

  render () {
    return (
      <React.Fragment>
        {this.props.children}
        {this.state.showPopup && this.renderPopup()}
      </React.Fragment>
    )
  }
}

const mapSateToProps = state => ({
  isAppBlocked: state.billingAndBlockStatusReducer.isAppBlocked,
  pendingBillings: state.billingAndBlockStatusReducer.pendingBillings,
  currentRoute: state.billingAndBlockStatusReducer.currentRoute,
  historyPush: state.billingAndBlockStatusReducer.historyPush,
  user: state.userReducer.user
})

export default connect(
  mapSateToProps,
  actions
)(NotificationPopup)



// WEBPACK FOOTER //
// ./src/services/NotificationPopup.js